module.exports = __webpack_public_path__ + "img/house.75f33dc7.svg";